import { WILDER_TX_SEARCH_URL } from "../config/wilder_requests/config";

export async function copyTxidAndOpenWilderExplorer(txid) {
  if (!txid) {
    return { ok: false, reason: "missing" };
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(txid);
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = txid;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(textarea);
      if (!copied) {
        return { ok: false, reason: "clipboard" };
      }
    }
  } catch {
    return { ok: false, reason: "clipboard" };
  }

  window.open(WILDER_TX_SEARCH_URL, "_blank", "noopener,noreferrer");
  return { ok: true };
}
